import createActionTypes from '../../constants/utils';

export const FETCH_SCHEDULERS = createActionTypes('SCHEDULERS');
